var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.281 1.59 2.001 1l.236 1.39 1.985 11.691-1.38 6.11-.11.482.402.288.47.337v.002h.003l9.8 7.03.194.14h.006L16.295 31l2.484-2.592.11-.08 9.69-7.002.1-.025-.01-.04.418-.302.374-.27-.076-.455-.922-5.536h.054l-.067-.075-.088-.535 1.4-10.983.156-1.216-1.15.424-8.487 3.126.011.029H11.691l.003-.006L3.28 1.59zm6.995 4.857L3.94 3.532l1.573 9.263 4.762-6.348zm-3.441 8.25 9.188 8.04 10.21-8.04H6.834zm20.168-1.713 1.129-8.851-6.756 2.49 5.628 6.36zm-2.274 9.288-5.982 4.323-2.502-2.137.188-.148 8.296-2.038zm-11.213 4.304 2.368-1.982-.149-.13-.148-.039-7.967-2.078 5.895 4.23zM5.437 15.454l-1.022 4.518 8.814 2.3-7.793-6.818zm22.397 4.522-.684-4.106-7.889 6.212 8.574-2.106zM7.064 13.21l4.69-6.254h7.928l5.531 6.253H7.064z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/FOX.f35202c38352ed180942cf04f2a02f7f.svg";
export { ForwardRef as ReactComponent };